/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { TileSettlement_jsonld } from './TileSettlement_jsonld';
export type TileLocation_jsonld = {
    readonly '@context'?: string | Record<string, any>;
    readonly '@id'?: string;
    readonly '@type'?: string;
    settlement?: TileSettlement_jsonld | null;
    latitude?: number | null;
    longitude?: number | null;
    address?: string;
    streetNumber?: string;
    postalCode?: string;
    currency?: TileLocation_jsonld.currency;
    isNocClone?: boolean;
};
export namespace TileLocation_jsonld {
    export enum currency {
        UNKNOWN = 'Unknown',
        HUF = 'HUF',
        EUR = 'EUR',
        GBP = 'GBP',
        RON = 'RON',
        PLN = 'PLN',
        USD = 'USD',
        CZK = 'CZK',
    }
}
